export default "__VITE_ASSET__bhxaF36j__"